/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompleteQuizRequest } from '../models/CompleteQuizRequest';
import type { CompleteQuizResponse } from '../models/CompleteQuizResponse';
import type { EnrollmentDto } from '../models/EnrollmentDto';
import type { EnrollmentRequest } from '../models/EnrollmentRequest';
import type { PageEnrollmentItem } from '../models/PageEnrollmentItem';
import type { QuizAttemptDto } from '../models/QuizAttemptDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnrollmentApiService {
    /**
     * @param id
     * @param requestBody
     * @returns EnrollmentDto Success response
     * @throws ApiError
     */
    public static update1(
        id: string,
        requestBody: EnrollmentRequest,
    ): CancelablePromise<EnrollmentDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/enrollments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user enrollments
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns PageEnrollmentItem User enrollments
     * @throws ApiError
     */
    public static getEnrollments(
        page?: number,
        size: number = 10,
        sort?: Array<string>,
    ): CancelablePromise<PageEnrollmentItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollments',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns EnrollmentDto Success response
     * @throws ApiError
     */
    public static create1(
        requestBody: EnrollmentRequest,
    ): CancelablePromise<EnrollmentDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param enrollmentId
     * @param stepId
     * @returns void
     * @throws ApiError
     */
    public static completeStep(
        enrollmentId: string,
        stepId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollments/{enrollmentId}/step/{stepId}/complete',
            path: {
                'enrollmentId': enrollmentId,
                'stepId': stepId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param enrollmentId
     * @param stepId
     * @returns QuizAttemptDto Success response
     * @throws ApiError
     */
    public static startQuiz(
        enrollmentId: string,
        stepId: string,
    ): CancelablePromise<QuizAttemptDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollments/{enrollmentId}/quiz/{stepId}/start',
            path: {
                'enrollmentId': enrollmentId,
                'stepId': stepId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param enrollmentId
     * @param stepId
     * @param requestBody
     * @returns CompleteQuizResponse Success response
     * @throws ApiError
     */
    public static completeQuiz(
        enrollmentId: string,
        stepId: string,
        requestBody: CompleteQuizRequest,
    ): CancelablePromise<CompleteQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollments/{enrollmentId}/quiz/{stepId}/complete',
            path: {
                'enrollmentId': enrollmentId,
                'stepId': stepId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get enrollment details
     * @param enrollmentId
     * @returns EnrollmentDto Enrollment details
     * @throws ApiError
     */
    public static getEnrollmentDetails(
        enrollmentId: string,
    ): CancelablePromise<EnrollmentDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollments/{enrollmentId}',
            path: {
                'enrollmentId': enrollmentId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get last quiz attempt
     * @param enrollmentId
     * @param stepId
     * @returns CompleteQuizResponse Success response
     * @throws ApiError
     */
    public static getLastAttempt(
        enrollmentId: string,
        stepId: string,
    ): CancelablePromise<CompleteQuizResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollments/{enrollmentId}/quiz/{stepId}/last-attempt',
            path: {
                'enrollmentId': enrollmentId,
                'stepId': stepId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
